import { render, staticRenderFns } from "./PageBeAccountable.vue?vue&type=template&id=5c9c74ae&"
import script from "./PageBeAccountable.vue?vue&type=script&lang=js&"
export * from "./PageBeAccountable.vue?vue&type=script&lang=js&"
import style0 from "./PageBeAccountable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports